<template>
    <div>
        <div class="list_box">
            <template v-for="(one,index) in list">
                <div class="box" :key="index">
                    <div class="top_box">
                        <div class="info"><span class="b">预约时间：</span>{{one.order_date}} {{one.time_title}}</div>
                        <div class="status" :class="{'color_red0':one.status==0,'color_green0':one.status==1,'color_grey1':one.status==2,'color_grey1':one.status==3}">{{status_arr[one.status]}}</div>
                    </div>
                    <div class="content_box">
                        <div class="info_line"><span class="b">预约时间段：</span>{{one.begin_time}} ~ {{one.finish_time}}</div>
                        <div class="info_line"><span class="b">预约游客：</span>{{one.member_names}}</div>
                    </div>
                    <div class="bottom_box" v-if="one.status == 0">
                        <div class="left">
                            <div class="btn" @click="routerToName('reserveRegisterMemberEdit', {activity_id, activity_record_id: one.id})">更改预约信息</div>
                        </div>
                        <div class="cut"></div>
                        <div class="right">
                            <div class="btn del" @click="delActivityRecord(one.id)">取消预约</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import mixins_reserve from '../../mixins/reserve'
    import * as api from "../../api/reserve";
    export default {
        name: "record"
        ,mixins: [mixins_reserve]
        ,data: function () {
            return {
                list: []
                ,status_arr: ['已预约','已完成','已过期','已取消']
                ,page: 1
                ,page_size: 20
            }
        }
        ,created: function() {
            this.getActivityRecord();
        }
        ,methods: {
            /**
             * 获取预约记录
             */
            getActivityRecord: function () {
                let that = this;

                api.getActivityRecord(that.activity_id, that.page, that.page_size).then(function (res) {
                    that.list = res.data.list;
                });
            }
            /**
             * 取消预约
             */
            ,delActivityRecord: function (id) {
                let that = this;

                that.$dialog.confirm({
                    message: "确定取消此次预约吗？"
                }).then(function () {
                    api.delActivityRecord(id).then(function () {
                        that.$toast('取消预约成功');
                        that.getActivityRecord();
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list_box{
        padding: .3rem;

        .box{
            border-radius: .2rem;
            margin-bottom: .3rem;
            background-color: $color_bg_grey0;
            box-shadow: $box_shadow_up;
            font-size: .3rem;

            .top_box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: .2rem;
                border-bottom: .02rem solid $color_bdr_grey1;

                .info{

                }
                .status{

                }
            }
            .content_box{
                padding: .2rem;

                .info_line{
                    margin-top: .1rem;
                }
            }
            .bottom_box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: .1rem .2rem;
                border-top: .02rem solid $color_bdr_grey1;

                > div{
                    width: 49%;
                }
                .cut{
                    width: 0;
                    height: .3rem;
                    border-left: .02rem solid $color_bdr_green0;
                }
                .btn{
                    width: 2.3rem;
                    height: .66rem;
                    line-height: .66rem;
                    margin: 0 auto;
                    border-radius: .06rem;
                    border: .02rem solid $color_bdr_green0;
                    background-color: $color_bg_green1;
                    color: #fff;
                    text-align: center;

                    &.del{
                        border-color: $color_bdr_grey0;
                        background-color: #fff;
                        color: $color_red0;
                    }
                }
            }

        }
    }
</style>